import React from 'react';
import PropTypes from 'prop-types';
import Theme from '../../themes';

const { borderRadius } = Theme.global;
const { main } = Theme.homes;
const { borderColor } = Theme.forms.inputs;

class SelectFrom extends React.PureComponent {
  handleOnClick = event => {
    event.preventDefault();
    const value = parseInt(event.target.value, 10);
    this.props.onChange(null, {
      [event.target.name]: value,
    });
  };

  render() {
    const { max, size, name, style, selectedOption } = this.props;

    return (
      <div className={`wrp ${size}`} style={style}>
        {[...Array(max + 1)].map((_, index) => {
          const key = `${name}-${index}`;
          return (
            <button
              data-test={key}
              value={index}
              key={key}
              name={name}
              type="button"
              className={index === selectedOption ? 'selected' : null}
              onClick={this.handleOnClick}
            >
              {index}+
            </button>
          );
        })}
        <style jsx>
          {`
            .wrp {
              display: flex;
              width: 100%;
            }
            button {
              border: 1px solid ${borderColor};
              border-left: 0;
              border-radius: 0;
              cursor: pointer;
              flex-grow: 1;
              flex-basis: auto;
              padding: 0.75em 0;
            }
            button:first-child {
              border-left: 1px solid ${borderColor};
              border-radius: ${borderRadius} 0 0 ${borderRadius};
            }
            button:last-child {
              border-radius: 0 ${borderRadius} ${borderRadius} 0;
            }
            :global(.rtl) button:first-child {
              border-radius: 0 ${borderRadius} ${borderRadius} 0;
              border-left: 0;
            }
            :global(.rtl) button:last-child {
              border-left: 1px solid ${borderColor};
              border-radius: ${borderRadius} 0 0 ${borderRadius};
            }
            .small button {
              font-size: 0.8125em; /* 13/16 */
              padding: 0.65em 0;
            }
            .medium button {
              font-size: 0.9375em; /* 15/16 */
              padding: 0.75em 0;
            }
            .big button {
              font-size: 1em; /* 16/16 */
              padding: 1em 0;
            }
            .selected {
              background: ${main};
              border-color: ${main};
              color: #fff;
            }
          `}
        </style>
      </div>
    );
  }
}

SelectFrom.defaultProps = {
  selectedOption: 0,
  max: 5,
  size: 'medium',
  style: null,
};

SelectFrom.propTypes = {
  selectedOption: PropTypes.number,
  name: PropTypes.string.isRequired,
  max: PropTypes.number,
  size: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export default SelectFrom;



// WEBPACK FOOTER //
// ./app/common/forms/SelectFrom.js